/**
 * One physical click on an outbound link can reach several trackers: the
 * document-level listener in useGlobalOutboundTracking plus per-link handlers
 * (useBlogAffiliateTracking, product/hub/collection card onClick handlers).
 * Each tracker claims the click first; only the first claim for a URL within
 * the window is reported, so GA4 receives one outbound event per click.
 */

const DEDUPE_WINDOW_MS = 1000;
const lastClaimedAt = new Map();

const normalizeUrl = (url) => {
  try {
    return new URL(url, window.location.href).href;
  } catch (e) {
    return String(url);
  }
};

export const claimOutboundClick = (url, now = Date.now()) => {
  const key = normalizeUrl(url);
  const last = lastClaimedAt.get(key);
  lastClaimedAt.set(key, now);
  return last === undefined || now - last >= DEDUPE_WINDOW_MS;
};

export default claimOutboundClick;
